import { render, staticRenderFns } from "./xcombos.vue?vue&type=template&id=396d54d2&scoped=true"
import script from "./xcombos.vue?vue&type=script&lang=js"
export * from "./xcombos.vue?vue&type=script&lang=js"
import style0 from "./xcombos.vue?vue&type=style&index=0&id=396d54d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396d54d2",
  null
  
)

export default component.exports